// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {combineReducers} from 'redux';
import {ActionTypes} from 'utils/constants.jsx';

function layoutState(state=false, action) {
    switch (action.type) {
    case 'COMPACT_MODE':
        return action.data;
    default:
        return state;
    }
}

export default combineReducers({
    layoutState
});
